import React from 'react'
import { Card, CardProps, Image } from '@red-ui/components'

type BannerProps = {
  children?: React.ReactNode
  imageUrl: string
  width: number
  height: number
} & CardProps

export const Banner = ({ children, imageUrl, width, height, ...props }: BannerProps) => (
  <Card width="100%" height={height} $gtMobile={{ width }} padding="$3" cursor="pointer" {...props}>
    <Card.Footer>{children}</Card.Footer>
    <Card.Background borderRadius="$4">
      <Image
        source={{
          uri: imageUrl,
          width,
          height,
        }}
        objectFit="cover"
      />
    </Card.Background>
  </Card>
)
